<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :layout="formLayout" :model="formData">
                    <a-divider dashed orientation="left">Form {{title}}</a-divider>

                    <a-form-model-item label="Nama">
                        <a-input v-model="formData.name"/>
                    </a-form-model-item>

                    <a-form-model-item label="Passing grade" v-show="materiType == 'modul'">
                        <a-input v-model="formData.passing_grade" type="number"/>
                    </a-form-model-item>


                    <a-form-model-item label="Order">
                        <a-input v-model="formData.order" type="number"/>
                    </a-form-model-item>

                    <a-form-model-item label="Keterangan">
                        <a-textarea
                            v-model="formData.description"
                            placeholder="Keterangan"
                            :auto-size="{ minRows: 3, maxRows: 5 }"
                        />
                    </a-form-model-item>

                    <a-form-model-item label="Lampiran" v-show="materiType == 'material'">
                        <a-button type="link" size="small" @click="download(formData.attachment)"
                            v-if="formData.attachment != null">
                            <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                        </a-button><br/>
                        <a-upload
                            :file-list="fileList"
                            :remove="handleRemove"
                            :before-upload="beforeUpload"
                            @change="handleChange"
                        >
                            <a-button>
                                <a-icon type="upload" /> Select File
                            </a-button>
                        </a-upload>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        material_id: {
            type: String,
            default: ''
        },
        materiType: {
            type: String,
            default: ''
        },
        parentId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formLayout: 'horizontal',
            formData: {
                order: 0
            },
            processing: false,
            preload: false,
            fileList: [],
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getModuleItem()
        }
    },
    computed: {
        editing() {
            return this.material_id !== ""
        },
        title(){
            return this.materiType
        }
    },
    methods: {
        getModuleItem() {
            this.preload = true
            this.$http
                .get(this.routeUri('api.material.show', { material: this.material_id }))
                .then(res => {
                    this.formData = res.data.material
                })
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.processing = true

            let promise

            let data = new FormData()

            data.append("name", this.formData.name)
            data.append("description", this.formData.description)
            data.append("order", this.formData.order)
            data.append("type", this.materiType)
            if(this.fileList.length > 0){
                data.append("attachment", this.fileList[0])
            }
            if(this.formData.passing_grade){
                data.append("passing_grade", this.formData.passing_grade)
            }
            if(this.parentId){
                data.append("parent_id", this.parentId)
            }
            if(!this.editing){
                promise = this.$http.post(this.routeUri('api.material.store'), data)
            }else{
                promise = this.$http.post(this.routeUri('api.material.update', {material: this.material_id}), data)
            }

            promise
                .then(response => this.handleSuccessResponse(response.data))
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false))
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            this.$emit("handleClose", true)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file)
            const newFileList = this.fileList.slice()
            newFileList.splice(index, 1)
            this.fileList = newFileList
            this.data = []
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            return false
        },
        handleChange(info) {
            let fileList = [...info.fileList]

            if (fileList.length > 1) {
                fileList = fileList.slice(-1)

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url
                    }
                    return file
                })
                this.fileList = fileList
            }
        },
        download(url) {
            window.open(url, '_blank')
        }
    },
}
</script>
